import {ReactElement} from "react";

import {Button} from "@/components/button/Button.tsx";
import {Tooltip} from "@/components/toolTip/Tooltip.tsx";

import "./moreList.css";

type MoreListProps<T> = {
  entries: T[];
  showEntries?: number;
  renderer: (entry: T) => ReactElement;
  bottomRenderer?: (entry: T) => ReactElement;
  variant?: "dropdown" | "tooltip";
};

const DEFAULT_SHOW_ENTRIES = 1;

export const MoreList = <T,>({
  entries,
  showEntries = DEFAULT_SHOW_ENTRIES,
  renderer,
  bottomRenderer,
  variant = "dropdown",
}: MoreListProps<T>) => {
  const moreLabel = ` +${entries.length - showEntries} more `;
  return (
    <div className="entry-container">
      {entries.slice(0, showEntries).map((entry, index) => (
        <div className="entry" key={index}>
          {renderer(entry)}
        </div>
      ))}
      {entries.length > showEntries &&
        (variant === "tooltip" ? (
          <Tooltip
            variant="light"
            interactive
            tooltipContent={
              <div className="more-list-popup" onClick={(e) => e.stopPropagation()} role="presentation">
                {entries.slice(showEntries).map((entry, index) => (
                  <div className="entry" key={index}>
                    {(bottomRenderer || renderer)(entry)}
                  </div>
                ))}
              </div>
            }
          >
            <Button variant="linkBlue" size="text" onClick={(e) => e.stopPropagation()}>
              {moreLabel}
            </Button>
          </Tooltip>
        ) : (
          <>
            <span className="cursor-pointer pulse-color-blue-600" data-bs-toggle="dropdown">
              {moreLabel}
            </span>
            <ul className="dropdown-menu">
              {entries.slice(showEntries).map((entry, index) => (
                <li className="px-2 entry" key={index}>
                  {(bottomRenderer || renderer)(entry)}
                </li>
              ))}
            </ul>
          </>
        ))}
    </div>
  );
};
